<template>
	<div id="login">
       <service
            :ws='ws'
            :data="data"
            :spinner="ws_spinner"
            @success='onSuccess'
            @error='console.log($event)'
        />
        <div class="wrapper-login">
            <div class="izda">
                <img class="logo" src="images/logo.png" />
                <div class="step_login">
                    <img v-if="!$store.state.usuario_loggeado.verified" :src="qrCode + usuario_loggeado.id">
                    <v-form class="form" @submit.prevent="submit" v-if="!this.$route.query['userId']" v-model="valid">
                        <div v-if="errorMessage" class="error-container">{{ $t(localeRoute + errorMessage) }}</div>
                        <v-text-field
                            :label="$t(localeRoute + 'code')"
                            :placeholder="$t(localeRoute + 'codePlaceholder')"
                            v-model="code"
                            ref="code"
                            @keyup.enter.prevent="submit"
                        ></v-text-field>
                        <v-btn class="boton" @click="submit" :loading="loading">{{$t(localeRoute + 'accept')}}</v-btn>

                    </v-form>
                </div>
            </div>
            <div class="dcha">
                <img src="images/foto_login.jpg" />
            </div>
        </div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import {webServices, urlQrCode} from '@/api/api.js'
import Service from '@/components/Service.vue'
import {locale} from '@/main.js'

export default {
	name: 'TFAuth',
	props: ['auto_login'],
    components: {Service},
    data() {
        return {
            localeRoute: `message.${[this.$options.name.toLowerCase()]}.`,
            usuario: null,
            user_id: null,
            nombre_usuario: null,
            error: '',
            info: '',
            valid: true,
            idioma: 'en',
            loader: null,
            loading: false,
            show: false,
            ws: null,
            data: null,
            ws_spinner: false,
            code: null,
            qrCode: urlQrCode,
            errorMessage: null,
            token: null,
        }
    },
	computed: {
        ...mapState([
            'usuarios', 'usuario_loggeado', 'token', 'started_point', 'idiomaGlobal', 'servicios'
        ]),
    },
    mounted: function() {
        setTimeout(() => {
            this.$refs.code.focus();
        }, 500);
        this.idioma = this.idiomaGlobal
        this.generateCode()
    },

    methods: {
        submit() {
            let vm = this;
            let ws = webServices.getToken();
            fetch(ws.url, ws.requestOptions)
                .then(result => {
                    this.data = {authCode: this.code, userId: vm.$store.state.usuario_loggeado.id};
                    this.ws = 'userCode';
                })
                .catch(error => console.log('error', error));
        },
        generateCode() {
            let vm = this;
            let ws = webServices.getToken();
            fetch(ws.url, ws.requestOptions)
                .then(response => {return response.text();})
                .then(result => {
                    this.data = {id: vm.$store.state.usuario_loggeado.id};
                    this.ws = 'generateCode';
                })
                .catch(error => console.log('error', error));
        },
        onSuccess(response) {
            if(typeof response.data !== 'undefined') {
                if (response.data.valid) {
                    this.$emit("logged");
                   // localStorage.setItem('isLogged', true);
                   // localStorage.setItem('usuario_logged', this.usuario_loggeado.id);
                    this.$router.push({path: '/home'});
                } else {
                    this.errorMessage = "badCode"
                }
            }
            this.ws = null;
            this.data = null;
            this.ws_spinner = false;
        }
	}
}
</script>
<style scoped lang="scss">
.error-container {
    background-color: red;
    font-size: 16px;
    color: white;
    padding: 5px;
    border-radius: 4px;
    width: 150px;
}
input {
    font-size: 18px!important;
}
#login {
    position: relative;
    width: 100vw;
    // min-height: 100vh;
    padding: 6% 1em 6% 15vw;
    background-image: url("/images/fondo_login.png");
    background-size: 100%;
    .wrapper-login {
        display: flex;
        justify-content: space-between;
    }
    .izda {
        flex: 1 1 27em;
        max-width: 33em;
        .logo {width: 20em; margin-bottom: 2em;}
        .titulo {
            font-size: 2.5em;
        }
        .idioma {
            display: flex;
            align-items: center;
            margin: 2em 0;
            cursor: pointer;
            .flag {
                width: 2em;
                margin-right: 1em;
            }
            .parrafo {margin: 0; border-bottom: 1px solid var(--color_texto)}
        }
        .parrafo {
            margin: 1em 0 2em;
            &.instrucciones {
                background-color: var(--gray02);
                padding: .8em;
                border-radius: 5px;
            }
        }
        .checkbox {width: 45%!important;}
        .boton {width: 100%; margin-top: 1.5em;}
        .small {
            margin-top: 1.5em;
            &.reset {
                color: var(--purple03);
                margin-bottom: .5em;
                cursor: pointer;
            }
            &.volver {color: var(--gray04);}
        }
        .info_msj {
            background-color: #27AE60;
            color: white;
            padding: .7em 1em;
            text-align: center;
            border-radius: 3px;
            min-width: 12em;
        }
    }
    .dcha {
        flex: 0 1 40vw;
        margin-left: 7em;
        img {
            position: relative;
            top: 20vh;
            width: 80%;
            max-width: 25rem;
            min-width: 14rem;
        }
    }
}
@media (max-width: 760px) {
    #login {
        padding: 6% 10%;
        background-image: none;
        .izda {
            width: 100%;
            .logo{
                width: 10em;
                margin-bottom: 0;
            }
        }
        .dcha {
            display: none;
        }
    }
}
</style>
